import React from 'react'

import ErrorBoundary from 'App/ErrorBoundary'

export const skipRenderOnError = (WrappedComponent) => (props) =>
  (
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: Element; fallback: null; }' is n... Remove this comment to see the full error message
    <ErrorBoundary fallback={null}>
      <WrappedComponent {...props} />
    </ErrorBoundary>
  )
